"use client";
import Icon from "@/components/atoms/Icons";
import { ISequentialCardsBlock } from "@/page-builder/fragments/SequentialCardsBlock/types";
import Image from "@/components/atoms/image";
import Heading from "../pb-sections/Heading";

export const ProcessFlow = ({ cards, title, description }: ISequentialCardsBlock) => {
  return (
    <section className="container mx-auto pb-64 xl:pb-96 flex flex-col gap-32 xl:gap-64">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
        <Heading title={title}/>
        <p className="text-m-regular">
          {description}
        </p>
      </div>
      <div
        className="grid grid-cols-6"
        role="list"
      >
        {Array.isArray(cards) &&
          cards.map((e, i) => {
            if (i == 0)
              return (
                <div
                  key={i}
                  role="listitem"
                  aria-label={`${i + 1}: ${e.title}`}
                  className="pt-[32px] pr-[32px] pl-[32px] pb-[32px] md:pt-[32px] md:pr-[32px] md:pl-[32px] md:pb-[44px] xl:pt-[44px] xl:pr-[44px] xl:pl-[44px] xl:pb-[44px] overflow-hidden xl:min-h-[360px] relative min-h-[332px] md:min-h-[336px] flex flex-col justify-between mr-0 xl:mr-[16px] mb-[32px] xl:mb-[84px] col-span-6 md:col-span-6 xl:col-span-2 bg-[#FEF8F6]"
                >
                  <div
                    className="relative z-20 flex items-center justify-center w-[120px] h-[120px]"
                    aria-hidden="true"
                  >
                    <Image fill className="object-contain" src={e.icon?.url || ""} alt={e.title} />
                  </div>
                  <div
                    className="absolute z-10 hidden md:flex xl:bottom-0 right-0 bottom-4"
                    aria-hidden="true"
                  >
                    <Icon name="fig4" />
                  </div>
                  <span className="text-xl-bold z-20 md:text-2xl-bold xl:text-2xl-bold text-neutral-900">
                    {e.title}
                  </span>
                </div>
              );
            else if (i == 1)
              return (
                <div
                  key={i}
                  role="listitem"
                  aria-label={`${i + 1}: ${e.title}`}
                  className="xl:ml-[16px] md:ml-0 overflow-hidden md:overflow-visible pt-[96px] pr-[32px] pl-[32px] pb-[32px] md:pt-[96px] md:pr-0 md:pl-[32px] md:pb-[44px] xl:pt-[96px] xl:pr-0 xl:pl-[44px] xl:pb-[44px] z-20 xl:min-h-[412px] relative min-h-[304px] md:min-h-[436px] flex justify-between flex-col xl:mt-[32px] mt-0 col-span-6 md:col-span-3 xl:col-span-2 bg-[#CFE5E0]"
                >
                  <div
                    className="relative flex items-center justify-center w-[120px] h-[120px]"
                    aria-hidden="true"
                  >
                    <Image fill className="object-contain" src={e.icon?.url || ""} alt={e.title} />
                  </div>
                  <div
                    className="absolute top-0 h-full w-full left-0 md:left-[50%]"
                    aria-hidden="true"
                  >
                    <div className="relative flex justify-center ml-[-16%] md:ml-[-10%] h-full w-[150%]">
                      <Icon name="fig5" />
                    </div>
                  </div>
                  <span className="text-xl-bold md:text-2xl-bold xl:text-2xl-bold text-neutral-900">
                    {e.title}
                  </span>
                </div>
              );
            else if (i == 2)
              return (
                <div  
                  key={i}
                  role="listitem"
                  aria-label={`${i + 1}: ${e.title}`}
                  className="relative pt-0 pr-[32px] pl-[32px] pb-[32px] md:pt-[96px] md:pr-[32px] md:pl-[32px] md:pb-[44px] xl:pt-[96px] xl:pr-[44px] xl:pl-[32px] xl:pb-[44px] z-10 xl:min-h-[412px] min-h-[304px] md:min-h-[436px] flex justify-between flex-col xl:mt-[32px] mt-0 col-span-6 md:col-span-3 xl:col-span-2 bg-[#CFE5E0]"
                >
                  <div
                    className="ml-auto md:ml-0 relative flex items-center justify-center w-[120px] h-[120px]"
                    aria-hidden="true"
                  >
                    <Image fill className="object-contain" src={e.icon?.url || ""} alt={e.title} />
                  </div>
                  <div
                    className="absolute z-10 hidden md:flex bottom-0 right-0"
                    aria-hidden="true"
                  >
                    <Icon name="fig6" />
                  </div>
                  <span className="text-xl-bold z-20 md:text-2xl-bold xl:text-2xl-bold text-neutral-900">
                    {e.title}
                  </span>
                </div>
              );
          })}
      </div>
    </section>
  );
};
